<template>
  <div class="animated fadeIn">
    <div class="row mt-4">
      <div class="col-12">
        <welcome :fromLogin="fromLogin" />
      </div>
    </div>
    <!-- <dynamic-dashboard></dynamic-dashboard> -->
    <!-- <reports-preview/> -->
  </div>
</template>

<script>
// import DynamicDashboard from '../../components/dashboard/DynamicDashboard.vue'
// import ReportsPreview from '../../components/dashboard/ReportPreview'
import Welcome from "../../components/dashboard/Welcome";
// import LastTimeUpdated from '../../components/dashboard/LastTimeUpdated'
import { mapGetters } from "vuex";
import { GETTER_USER_INFO, GETTER_FROM_LOGIN_DETECT } from "@/store/modules/users/constants";
export default {
  name: "home",
  components: {
    // DynamicDashboard,
    Welcome,
    // LastTimeUpdated,
    // ReportsPreview,
  },
  computed: {
    fromLogin() {
      return this.fromLoginDetect;
    },
    userInfo() {
      return this.getUserInfo;
    },
    isClientAdmin() {
      return this.userInfo.roles
        && this.userInfo.roles.data
        && this.userInfo.roles.data.length
        && this.userInfo.roles.data[0].name === 'client_admin';
    },
    ...mapGetters({
      getUserInfo: GETTER_USER_INFO,
      fromLoginDetect: GETTER_FROM_LOGIN_DETECT
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue